module.exports = __webpack_public_path__ + "static/media/DSC09694.5feaa4df.jpg";